import React from "react";

function OurMission() {

    return (

        <section className="py-5 mt-5">
                <div className="container">
                    <h2 className="text-center mb-4 heading">Our <span className="purple-text">Mission</span></h2>
                    <div className="row justify-content-center">
                        <div className="col-lg-8">
                            <p className="text-center fs-5">
                                At VersaCore, our mission is to deliver high-quality products on time,
                                ensuring the highest level of customer satisfaction.
                                In a competitive market, we strive to stand out by consistently meeting our customers' needs
                                with precision and reliability. We are committed to fostering a friendly and inclusive
                                workplace where every employee is valued, free from any form of discrimination.
                                By building a culture of trust and respect,
                                we aim to drive success and innovation for both our customers and team members.
                            </p>
                        </div>
                    </div>
                </div>
            </section>

    );
}

export default OurMission;